const defaultMentionStyle = {
  backgroundColor: "#D3D3D3",
};

export default defaultMentionStyle;
